import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  InputLabel,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
  Typography,
  FormControl,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Edit } from "@mui/icons-material";
import { getUsers } from "../../endpoints/api";

type MachineNameProps = {
  handleNext: (serialCode: string, userId: string) => void;
  handleBack?: () => void;
};

const MachineName: React.FC<MachineNameProps> = ({
  handleNext,
  handleBack,
}) => {
  const { t } = useTranslation();

  const [serialCode, setSerialCode] = useState<string>("");
  const [user, setUser] = useState<string>("");

  const [users, setUsers] = useState<{ name: string; id: string }[]>([]);
  useEffect(() => {
    getUsers().then((users: any) => {
      let tmpUsers: { name: string; id: string }[] = [];
      if (users && users.length > 0) {
        users.forEach((u: any) => {
          if (u && u.email && u.id) {
            tmpUsers.push({ name: u.email, id: u.id });
          }
        });
        setUsers(tmpUsers);
      }
    });
  }, []);

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Grid item>
        <Edit style={{ fontSize: "64px" }} />
      </Grid>
      <Grid item>
        <Typography variant="h5">{t("configureDevices")}</Typography>
      </Grid>
      <Grid item>
        <Typography>{t("nameMachineDescription")}</Typography>
      </Grid>
      <Grid
        container
        item
        spacing={4}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={8} xl={6}>
          <Grid container spacing={1} direction="column">
            <Grid item>
              <TextField
                size="medium"
                data-testid="serialCode"
                value={serialCode}
                onChange={(e) => setSerialCode(e.target.value)}
                fullWidth
                label={t("serialCode")}
              />
            </Grid>
            <Grid item>
              <FormControl fullWidth style={{ textAlign: "start" }}>
                <InputLabel id="user-label">{t("user")}</InputLabel>
                <Select
                  labelId="user-label"
                  value={user}
                  label={t("fleet")}
                  onChange={(event: SelectChangeEvent) =>
                    setUser(event.target.value as string)
                  }
                >
                  {users.length > 0 &&
                    users.map((f) => {
                      return <MenuItem value={f.id}>{f.name}</MenuItem>;
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Grid
                container
                spacing={2}
                display="flex"
                alignItems="flex-start"
                justifyContent="space-between"
              >
                {handleBack && (
                  <Grid item>
                    <Button
                      data-testid="back"
                      size="large"
                      variant="contained"
                      style={{ float: "left", marginTop: "8px" }}
                      onClick={() => handleBack()}
                    >
                      {t("back")}
                    </Button>
                  </Grid>
                )}
                <Grid item xs></Grid>
                <Tooltip title={serialCode ? "" : `${t("fillInAllFields")}`}>
                  <Grid item>
                    <Button
                      data-testid="next"
                      disabled={!serialCode || !user}
                      size="large"
                      variant="contained"
                      style={{ float: "right", marginTop: "8px" }}
                      onClick={() => handleNext(serialCode, user)}
                    >
                      {t("next")}
                    </Button>
                  </Grid>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MachineName;
